<template>
  <div>
    <div v-if="isHumanMode" class="wa__advisor-banner">
      Escribiendo como asesor — el empleado recibirá este mensaje en WhatsApp
    </div>
    <div
      v-if="!isHumanMode"
      class="wa__input-locked"
      title="Haz clic para pausar el bot"
      @click="$emit('request-pause')"
    >
      <i class="fas fa-robot"></i>
      <span
        >El bot está activo —
        <strong>pausa el bot</strong> para escribir</span
      >
    </div>
    <div class="wa__input-bar">
      <input
        v-model="draft"
        type="text"
        class="wa__input"
        :placeholder="
          !isHumanMode
            ? 'Pausa el bot para escribir mensajes'
            : 'Escribe un mensaje...'
        "
        :disabled="sending || !isHumanMode"
        :title="!isHumanMode ? 'Para enviar mensajes pausa el bot' : ''"
        @keydown.enter.exact.prevent="isHumanMode ? sendMessage() : null"
      />
      <button
        class="wa__send-btn"
        :disabled="sending || !draft.trim() || !isHumanMode"
        :title="!isHumanMode ? 'Para enviar mensajes pausa el bot' : ''"
        @click="sendMessage"
      >
        <i class="fas fa-paper-plane"></i>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "WaInputBar",
  props: {
    sending: {
      type: Boolean,
      default: false,
    },
    isHumanMode: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["send-message", "request-pause"],
  data() {
    return {
      draft: "",
    };
  },
  methods: {
    sendMessage() {
      const text = this.draft.trim();
      if (!text || this.sending || !this.isHumanMode) {
        return;
      }
      this.draft = "";
      this.$emit("send-message", text);
    },
  },
};
</script>
